import { Fragment } from 'react';
import format from 'date-fns/format';
import withPermissionProtection from 'hoc/withPermissionProtection';

// Components
import Grid from '@material-ui/core/Grid';
import DataTable from 'components/CncUI/DataTable';
import Typography from 'components/CncUI/Typography';

const RegistrationLogTable = props => {
  const { records, loading } = props;

  const columns = [
    {
      field: 'time',
      label: 'Timestamp',
      value: ({ time }) => format(time, 'MMM, do yyyy'),
      headerProps: { style: { minWidth: 100 } },
    },
    {
      field: 'path',
      label: 'Registration Path',
      headerProps: { style: { minWidth: 140 } },
    },
    {
      field: 'category',
      headerProps: { style: { minWidth: 140 } },
    },
    {
      field: 'reason',
      label: 'Failure Reason',
      headerProps: { style: { width: '19%' } },
    },
    {
      field: 'data',
      sortable: false,
      headerProps: { style: { width: '45%' } },
      value: ({ data }) => {
        const parsedData = JSON.parse(data);
        const keys = Object.keys(parsedData).filter(
          k => k !== 'recaptchaToken',
        );
        return keys.map(key => (
          <Fragment key={`data-${key}`}>
            <b>{key}</b>
            {`: ${parsedData[key]}`}
            <br />
          </Fragment>
        ));
      },
    },
  ];

  return (
    <Grid container spacing={0}>
      <Grid item xs={12}>
        <Typography variant="h5">Registration Status Report</Typography>
      </Grid>
      <Grid item xs={12}>
        <DataTable
          transparent
          columns={columns}
          data={loading ? [] : records}
          pageSize={5}
          sort="time"
          order="desc"
        />
      </Grid>
    </Grid>
  );
};

export default withPermissionProtection({
  permissions: 'employee_registrations:read',
  fallback: null,
})(RegistrationLogTable);
